import { appEnvironment } from "config/environment.config";
import { ApiBuilder } from "@epcnetwork/core-ui-kit";
import { LoginResponse } from "api/auth/auth.interface";

export const apiRefreshEndpoint = "/auth/token/refresh";

export const refreshTokenMiddleware = new ApiBuilder({ baseUrl: appEnvironment.apiUrl }).build();

export const postRefreshToken = refreshTokenMiddleware<
  LoginResponse,
  Omit<LoginResponse, "token">
>()({
  endpoint: apiRefreshEndpoint,
  method: "post",
});
